<h2 data-cy="delete-user-dialog-title" mat-dialog-title class="!p-4">Delete User</h2>
<mat-dialog-content>
	<div class="flex">
		<div class="flex-1 !p-2">
			<p>	Are you sure you want to delete the user for <span class="font-bold">{{ data.portalUser.first }} {{ data.portalUser.last }}</span>?</p>
		</div>
	</div>
	<div class="flex">
		<div class="flex-1 text-right">
			<button mat-button (click)="close()">No</button>
			<button data-cy="delete-user-confirm" mat-flat-button color="primary" class="!ml-2" (click)="deleteUser()">Yes</button>
		</div>
	</div>
</mat-dialog-content>
